/**
 * Copyright © IMPACT Commerce AB. All rights reserved.
 * See COPYING.txt for license details.
 */

/**
 * Clicking the rating or the "X reviews" count below the header review stars
 * opens the reviews drawer (`<dialog-component data-reviews-drawer>`, rendered
 * by `snippets/reviews-drawer.liquid`).
 *
 * Falls back to the older Reviews accordion (`<details
 * data-pdp-reviews-accordion>`) for templates that still have one and no
 * drawer — those PDPs keep working untouched.
 *
 * Skipped when the click is inside a `<summary>`: the same review-stars
 * snippet is rendered in an accordion's own summary header, and clicking
 * there should toggle the accordion via native `<summary>` behaviour.
 */
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  const trigger = event.target.closest('.review-stars__count, .review-stars__rating');
  if (!trigger) return;

  // Inside a <summary> → let native toggle handle it.
  if (trigger.closest('summary')) return;

  const drawer = /** @type {any} */ (document.querySelector('[data-reviews-drawer]'));
  if (drawer && typeof drawer.showDialog === 'function') {
    drawer.showDialog();
    return;
  }

  const accordion = document.querySelector('[data-pdp-reviews-accordion]');
  if (!(accordion instanceof HTMLDetailsElement)) return;

  accordion.open = true;
  accordion.scrollIntoView({ behavior: 'smooth', block: 'start' });
});
